<template>
  <div v-if="doneBillFetch" class="settings scrollbar">
    <div class="header">
      <h1>Monthly Bill</h1>
      <p>{{ Month }},{{ Year }}</p>
      <div class="date-selector settings__control-group">
        <select v-model="selectMonth" class="select">
          <option v-for="(m, i) in months" :key="i" :value="m">
            {{ m }}
          </option>
        </select>
        <select v-model="selectYear" class="select">
          <option v-for="(y, i) in years" :key="i" :value="y">
            {{ y }}
          </option>
        </select>
        <button class="button button-rounded" @click="retrieveMonthlyBill">Retrieve</button>
      </div>
    </div>
    <div class="usage-monitor">
      <div class="table-container">
        <v-data-table
          :headers="headers"
          :items="mainTableRows"
          item-value="name"
          :group-by="groupBy"
          :items-per-page="-1"
          density="comfortable"
        >
          <template #top>
            <div class="table-flex-end">
              <span>Net Usage (approx.): ${{ BillPayable.toFixed(2) }}</span>
            </div>
          </template>
          <template #group-header="{ item, columns, toggleGroup, isGroupOpen }">
            <tr>
              <td :colspan="columns.length - 2">
                <v-btn
                  size="small"
                  variant="text"
                  :icon="isGroupOpen(item) ? 'mdi-chevron-down' : 'mdi-chevron-up'"
                  @click="toggleGroup(item)"
                />
                {{ item.value }}
              </td>
              <td :colspan="2" class="total-credit-group">
                <span>
                  {{ `$ ${Number(Math.abs(getCreditForKey(item.value))).toLocaleString(userLocale, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}` }}
                </span>
              </td>
            </tr>
          </template>
          <template #[`header.date`]>
            <div class="date-col">
              <span>Date</span>
              <div class="tz-selector">
                <input
                  id="option-local"
                  v-model="selectTimeZone"
                  type="radio"
                  name
                  :value="'local'"
                >
                <label for="option-local">Local</label>
                <input
                  id="option-utc"
                  v-model="selectTimeZone"
                  type="radio"
                  :value="'utc'"
                >
                <label for="option-utc">UTC</label>
              </div>
            </div>
          </template>
          <template v-for="header in headers" #[`item.${header.key}`]="{ item }">
            <template v-if="header.key=='description' || header.key=='date' ">
              {{ `${item[header.key]}` }}
            </template>
            <template v-else-if="header.key=='rate'">
              $ {{ `${item[header.key]}` }} / hour
            </template>
            <template v-else-if="header.key=='duration'">
              {{ `${item[header.key]}` }}
            </template>
            <template v-else>
              $ {{ `${Number(item[header.key]).toLocaleString(userLocale, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}` }}
            </template>
          </template>
          <template #bottom />
        </v-data-table>
      </div>
    </div>
  </div>
  <div v-else class="empty-state">
    <div id="loading-visualization"><div class="lds-ring"><div /><div /><div /><div /></div></div>
  </div>
  <RequestFundsModal v-if="showRequestModal" ref="requestFundsModal" v-model:show="showRequestModal" />
</template>

<script>
import DatastoreConnect from '@/assets/js/DatastoreFunctions/datastore-interface';
import RequestFundsModal from '@/components/RequestFundsModal.vue';
import { useToast } from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-sugar.css';

const $toast = useToast();

export default {
  name: 'Bills',
  components: {
    RequestFundsModal,
  },
  data() {
    return {
      dsConn: new DatastoreConnect(this.$store.state.enterpriseServerUrl),
      dollars: 0,
      BillPayable:0,
      numProject: 0,
      numDataset: 0,
      showDetailedDatasets: false,
      hasDetailedDatasets: false,
      showDetailedImages: false,
      hasDetailedImages: false,
      numFiles: 0,
      numSize: 0,
      aigtTime: 0,
      numTasks: 0,
      summaryStart: null,
      summaryEnd: null,
      refreshTimeOut: false,
      Month: "",
      Year: "",
      selectedMonth: "",
      selectedYear: "",
      headers: [
        {
          title: 'Description', key: 'description', sortable: false, width: '40%',
        },
        {
          title: 'Date', key: 'date', width: '20%', sortable: false, align: 'center',
        },
        {
          title: 'Rate', key: 'rate', width: '10%', sortable: false, align: 'end',
        },
        {
          title: 'Duration', key: 'duration', sortable: false, width: '10%', align: 'end',
        },
        {
          title: 'Cost', key: 'cost', sortable: false, width: '10%', align: 'end',
        },
        {
          title: 'Charge', key: 'charge', sortable: false, width: '10%', align: 'end',
        },
      ],

      BillTypes: {
        trainer: "Training Time (Duration in Hours)",
        validation: "Validation Time (Duration in Hours)",
        aigt: "AIGT Time (Duration in Hours)",
        snapshot_create: "Snapshot Create Time (Duration in Hours)",
        snapshot_restore: "Snapshot Restore Time (Duration in Hours)",
      },
      groupBy: [
        {
          key: 'type',
          order: 'asc',
        },
      ],
      orgId: 0,
      selectMonth: '',
      selectYear: 0,
      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      selectTimeZone: 'local',
      doneBillFetch: false,
      userLocale: navigator.language || 'en-US',
      organization: null,
      bills: [],
      selectedBill: null,
      showRequestModal: false,
    };
  },
  computed: {
    doneFetch() {
      return this.doneBillFetch;
    },
    user() {
      return this.$store.state.user.user;
    },
    months() {
      return [
        'January', 'February', 'March', 'April', 'May', 'June',
        'July', 'August', 'September', 'October', 'November', 'December',
      ];
    },
    years() {
      const currentYear = new Date().getFullYear();
      const startingYear = 2023;
      const years = [];
      for (let year = startingYear; year <= currentYear; year++) {
        years.push(year);
      }

      return years;
    },
    totalAIGTCredit() {
      let count = 0;
      this.aigtRecord.forEach((record) => {
        count += Number.parseFloat(record.charge);
      });
      return count;
    },
    totalSnapshotRestoreCredit() {
      let count = 0;
      this.snapshotRestoreRecord.forEach((record) => {
        count += Number.parseFloat(record.charge);
      });
      return count;
    },
    totalSnapshotCreationCredit() {
      let count = 0;
      this.snapshotCreationRecord.forEach((record) => {
        count += Number.parseFloat(record.charge);
      });
      return count;
    },
    totalTrainingCredit() {
      let count = 0;
      this.trainingTimeRecord.forEach((record) => {
        count += Number.parseFloat(record.charge);
      });
      return count;
    },
    totalValidationCredit() {
      let count = 0;
      this.validationTimeRecord.forEach((record) => {
        count += Number.parseFloat(record.charge);
      });
      return count;
    },

    mainTableRows() {
      return [...this.trainingTimeRecord,
        ...this.autoAnnRecord, ...this.validationTimeRecord, ...this.snapshotCreationRecord, ...this.snapshotRestoreRecord,
        ...this.aigtRecord];
    },
  },
  watch: {
    showDetailedDatasets(v) {
      if (v) {
        this.getDetailedDatasets();
      }
    },
    showDetailedImages(v) {
      if (v) {
        this.getDetailedImages();
      }
    },
    selectTimeZone(val) {
      if (val === 'utc') {
        this.timeZone = 'UTC';
      } else if (val === 'local') {
        this.timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      }
      this.retrieveMonthlyBill();
    },
  },
  created() {
    if (this.$route.query.org) {
      this.orgId = parseInt(this.$route.query.org);
    }
    this.selectMonth = this.months[new Date().getMonth()];
    this.selectYear = new Date().getFullYear();
  },
  async mounted() {
    await this.retrieveMonthlyBill();
  },
  methods: {
    formatBillDate(d) {
      if (!d) {
        return null;
      }
      const date = new Date(d);
      const options = { month: 'short' }; // gives "Jan", "Feb", etc.
      const month = new Intl.DateTimeFormat('en-US', options).format(date);
      const day = date.getDate();
      const year = date.getFullYear();
      return `${month} ${day}, ${year}`;
    },
    formatBytes(bytes) {
      const units = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
      if (bytes === 0) return '0 Bytes';

      const i = Math.floor(Math.log(bytes) / Math.log(1000));
      const size = bytes / 1000 ** i;

      return `${size.toFixed(2)} ${units[i]}`;
    },
    parseDuration(hrs) {
      const msDiff = hrs * 3600 * 1000;
      const minutes = Math.floor(msDiff / (1000 * 60)) % 60;
      const hours = Math.floor(msDiff / (1000 * 60 * 60)) % 24;
      const days = Math.floor(msDiff / (1000 * 60 * 60 * 24));
      const result = [];
      if (days > 0) result.push(`${days} day${days > 1 ? 's' : ''}`);
      if (hours > 0) result.push(`${hours} hr${hours > 1 ? 's' : ''}`);
      if (minutes > 0) result.push(`${minutes} min${minutes > 1 ? 's' : ''}`);
      return result.join(" ") || "0 mins";
    },
    parseLocaleNumber(stringNumber, locale) {
    // Create a NumberFormat object for the specific locale
      const formatter = new Intl.NumberFormat(locale);

      // Extract the parts from the formatted number
      const parts = formatter.formatToParts(1234.56);
      const groupSeparator = parts.find((part) => part.type === 'group').value;
      const decimalSeparator = parts.find((part) => part.type === 'decimal').value;

      // Remove group separators and replace the decimal separator with a dot
      const normalizedNumber = stringNumber.toString()
        .replace(new RegExp(`\\${groupSeparator}`, 'g'), '')
        .replace(decimalSeparator, '.');

      // Parse the normalized number using parseFloat
      return parseFloat(normalizedNumber);
    },
    async retrieveMonthlyBill() {
      this.doneBillFetch = false;
      const y = this.selectYear;
      const m = this.months.indexOf(this.selectMonth) + 1;
      await this.dsConn.retrieveMonthlyBill({
        organization_id: this.orgId,
        month: m,
        year: y,
      })
        .then((resp) => {
          if (resp.result) {
            this.BillPayable=resp.result.total_payable;
            this.parseReport(resp.result);
          } else {
            $toast.open({
              queue: true,
              duration: 5000,
              message: `Error retrieving monthly bill`,
              type: "error",
              position: "top",
            });
          }
          this.doneBillFetch = true;
        })
        .catch((e) => {
          $toast.open({
            queue: true,
            duration: 5000,
            message: `Error retrieving monthly bill`,
            type: "error",
            position: "top",
          });
          this.doneBillFetch = true;
        });
    },
 
    getCreditForKey(key) {
      switch (key) {
      case this.BillTypes.trainer:
        return this.totalTrainingCredit;
      case this.BillTypes.validation:
        return this.totalValidationCredit;
      case this.BillTypes.aigt:
        return this.totalAIGTCredit;
      case this.BillTypes.snapshot_create:
        return this.totalSnapshotCreationCredit;
      case this.BillTypes.snapshot_restore:
        return this.totalSnapshotRestoreCredit;
      default:
        return 0;
      }
    },

    ProcessBillEntry(curr, type) {
      const obj = {
        type,
        description: curr.comments,
        date: new Date(curr.date).toLocaleString('default', {
          year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric', hour12: true, timeZone: this.timeZone,
        }),
        rate: curr.rate,
        duration: `${Number(curr.duration).toFixed(3).toLocaleString()}`,
        amount: '-',
        cost: curr.price,
        charge: curr.amount_billed,
      };
      return obj;
    },
    parseReport(data) {
      this.Year = data.year;
      this.Month = this.months[data.month - 1];
      // training
      const training_array = data.entries.filter((e) => e.type === 'trainer');
      const reduced_training_array = training_array.reduce((acc, curr) => {
        const obj = this.ProcessBillEntry(curr, this.BillTypes.trainer);
        acc.push(obj);
        return acc;
      }, []);
      this.trainingTimeRecord = reduced_training_array;

      // aigt
      const aigt_array = data.entries.filter((e) => e.type === 'aigt');
      const reduced_aigt_array = aigt_array.reduce((acc, curr) => {
        const obj = this.ProcessBillEntry(curr, this.BillTypes.aigt);
        acc.push(obj);
        return acc;
      }, []);
      this.aigtRecord = reduced_aigt_array;

      this.autoAnnRecord = [];

      // validation
      const validation_array = data.entries.filter((e) => e.type === 'validation');
      const reduced_validation_array = validation_array.reduce((acc, curr) => {
        const obj = this.ProcessBillEntry(curr, this.BillTypes.validation);
        acc.push(obj);
        return acc;
      }, []);
      this.validationTimeRecord = reduced_validation_array;

      // snapshot_restore
      const snapshot_restore_array_array = data.entries.filter((e) => e.type === 'snapshot-restore');
      const reduced_snapshot_restore_array = snapshot_restore_array_array.reduce((acc, curr) => {
        const obj = this.ProcessBillEntry(curr, this.BillTypes.snapshot_restore);
        acc.push(obj);
        return acc;
      }, []);
      this.snapshotRestoreRecord = reduced_snapshot_restore_array;

      // snapshot_creation
      const snapshot_creation_array = data.entries.filter((e) => e.type === 'snapshot-create');
      const reduced_snapshot_creation_array = snapshot_creation_array.reduce((acc, curr) => {
        const obj = this.ProcessBillEntry(curr, this.BillTypes.snapshot_create);
        acc.push(obj);
        return acc;
      }, []);
      this.snapshotCreationRecord = reduced_snapshot_creation_array;
    },
    timeOut() {
      this.refreshTimeOut = true;
      setTimeout(() => { this.refreshTimeOut = false; }, 10000);
    },
  
    openRequestFundsModal() {
      this.showRequestModal = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.flex-col {
  display: flex;
  flex-direction: column;
}

.refresh-usage {
  width: fit-content;
}
.settings {
  display: flex;
  flex-direction: column;
  width: 100%;
  min-width: 400px;
  height: 100%;
  padding: 30px;
  overflow-y: auto;
}

.empty-state {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  width: 100%;
  height: 100%;
}

.date-selector {
  width: 380px;
  display: flex;
  flex-direction: row;
  margin-left: 20px;
  font-size: 1rem;
  font-weight: 500;

  select + select {
    margin-left: 20px;
  }

  button {
    margin-left: 20px;
  }
}

.static-summary {
  width: 100%;
  display: grid;
  grid-gap: 30px;
  padding: 15px;
  grid-template-columns: repeat(auto-fill, 370px);
  grid-auto-rows: auto;
  border-radius: 8px;
  margin-top: 20px;
  box-shadow: 1px 1px 4px 1px rgba(0, 0, 0, 0.2), 0 0 1px 1px rgba(0, 0, 0, 0.05);
  @include themify() {
    background: themed('card-color');
    color: themed('body-text-color');
  }

  &__item {
    display: flex;
    flex-direction: row;
    justify-content: space-between;

    .icon +.progress {
      margin-left: 20px;
    }
  }

  &__item > .label {
    width: 200px;
    text-align: right;
    font-size: 0.9rem;
    font-weight: 600;
    color: rgba(grey, 0.9);

    &.required::after {
      content: '*';
      font-size: 14px;
      font-weight: 700;
      padding-left: 1px;
      @include themify() {
        color: themed('color-primary');
      }
    }
  }

  &__item > .value {
    flex: 1 1 auto;
    font-size: 0.9rem;
    margin-left: 20px;
  }
}

.header {
  font-size: 1.2rem;
  font-weight: 700;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}

.header-2 {
  font-size: 1.1rem;
  font-weight: 600;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}

.subtitle {
  font-size: 0.9rem;
}

.icon {
  width: fit-content;
  display: flex;
  align-items: center;
  justify-content: center;
}

.progress {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;

  &__title {
    display: flex;
    width: 100%;
    font-size: 1.0rem;
    font-weight: 600;
    @include themify() {
    color: themed('body-text-color');
    }
    span {
      margin-right: 5px
    }
  }

  &__subtitle {
    display: flex;
    width: 100%;
    font-size: 1rem;
    font-weight: 600;
    justify-content: space-between;
    @include themify() {
    color: themed('body-text-color-secondary');
    }

    div:first-child {
    margin-bottom: 5px;
    }
  }

  &__bar {
      display: flex;
      flex-direction: column;
      width: 100%;
      margin-top: 1px;

      progress {
      width: 100%;
      border-radius: 0;
      height: 10px;

        &::-webkit-progress-bar {
            @include themify() {
            background-color: themed('progress-bar');
            }
        }
        &::-webkit-progress-value {
            @include themify() {
            background-color: themed('progress-value');
            }
        }
      }
  }

  &__estimate {
      display: flex;
      font-weight: 600;
      font-size: 0.875rem;
      @include themify() {
      color: themed('body-text-color-secondary');
      }
      margin-top: 5px;
      justify-content: space-between;
  }
}
.usage-monitor {
  .radio-group {
    display: inline-block;
    margin: 10px 0 20px 0;
    border-radius: 5px;
    overflow: hidden;
    border: solid 1px black
  }

  .radio-group input[type="radio"] {
    position: absolute;
    opacity: 0;
    pointer-events: none;
  }

  .radio-group input[type="radio"] + label {
    min-width: 6rem;
    max-width: 50%;
    text-align: center;
    display: inline-block;
    cursor: pointer;
    font-size: 0.9rem;
    line-height: 1.5;
    padding: 5px 20px;
    transition: all 0s ease;
    @include themify() {
      background: themed('card-color');
      color: themed('body-text-color');
    }
  }

  .radio-group input[type="radio"]:not(:disabled):hover + label {
    @include themify() {
      background: themed('color-primary-300');
      color: themed('primary-text-color');
    }
  }

  .radio-group input[type="radio"]:checked + label,
  .radio-group input[type="radio"]:checked:hover + label {
    opacity: 1;
    z-index: 1;
    @include themify() {
      background: themed('color-primary');
      color: themed('primary-text-color');
    }
  }

  .table-container {
    width: 100%;
    padding: 15px;
    border-radius: 8px;
    margin-top: 20px;
    box-shadow: 1px 1px 4px 1px rgba(0, 0, 0, 0.2), 0 0 1px 1px rgba(0, 0, 0, 0.05);
    @include themify() {
      background: themed('card-color');
      color: themed('body-text-color');

    }
  }

  :deep(tbody tr:nth-of-type(odd)) {
    background-color: rgba(0, 0, 0, .05);
  }

  :deep(thead > tr > th:nth-child(1)) {
    color: transparent;
    max-width: 60px;
  }
  .table-flex-end {
    display: flex;
    justify-content: end;

      span {
      font-size: 1rem;
      font-weight: 600;
    }
  }
  .total-credit-group{
    text-align: end;
    font-weight: 550;

    span {
      margin-left: auto;
      font-size: 1.0rem;
    }
  }

  .radio-group {
    display: inline-block;
    margin: 10px 0 20px 0;
    border-radius: 5px;
    overflow: hidden;
    border: solid 1px black
  }

  .radio-group input[type="radio"] {
    position: absolute;
    opacity: 0;
    pointer-events: none;
  }

  .radio-group input[type="radio"] + label {
    min-width: 6rem;
    max-width: 50%;
    text-align: center;
    display: inline-block;
    cursor: pointer;
    font-size: 0.9rem;
    line-height: 1.5;
    padding: 5px 20px;
    transition: all 0s ease;
    @include themify() {
      background: themed('card-color');
      color: themed('body-text-color');
    }
  }

  .radio-group input[type="radio"]:not(:disabled):hover + label {
    @include themify() {
      background: themed('color-primary-300');
      color: themed('primary-text-color');
    }
  }

  .radio-group input[type="radio"]:checked + label,
  .radio-group input[type="radio"]:checked:hover + label {
    opacity: 1;
    z-index: 1;
    @include themify() {
      background: themed('color-primary');
      color: themed('primary-text-color');
    }
  }
}

.added-fund {
  color: var(--color-success)
}

.unit {
  font-size: 0.85rem !important;
  font-weight: 500 !important;
}

.detail-icon {
  cursor: pointer;
  @include themify() {
    color: themed('icon-color-primary');
  }
  &:hover {
    @include themify{
      background-color: themed('icon-hover-color');
      border-radius: 100%;
      box-shadow: 0 0 0 4px themed('icon-hover-color');
    }
  }
}

.date-col {
  display: flex;
  flex-direction: row;
  justify-content: center;

  .tz-selector {
    margin-left: 5px;

    input[type="radio"] {
      display: none;
    }

    label {
      padding: 2px 5px;
      width: fit-content;
      font-size: 0.85rem;
      font-weight: bold;
      color: var(--gray-500);
      cursor: pointer;
    }

     input[type="radio"]:checked+label {
      @include themify() {
        color: themed('color-primary-500');
      }
    }
  }
}

#usage-request-funds-btn {
  width: 180px;
}
</style>
